import { FC } from 'react';
import cx from 'classnames';

import { Card } from '../Card';
import { RoundedButton } from '../RoundedButton';
import { RowItem, isCardWImage, isRoundedButtonLink } from '../types';

import styles from './Rows.module.scss';

type RowsProps = {
  className?: string;
  items: RowItem[];
};

export const Rows: FC<RowsProps> = ({ className, items }) => {
  return (
    <div className={cx(styles.Rows, className)}>
      {items.map((row, rowIndex) => {
        return (
          // `row.title` is rendered by the mobile nav only
          <div key={`row-${rowIndex}`} className={styles.Row}>
            <ul
              className={cx(styles.Row__grid, {
                [styles.Row__grid_single]: row.columns === 1,
                [styles.Row__grid_iconRows]: !row.children.some(isCardWImage),
              })}
            >
              {row.children.map((item, itemIndex) => {
                if (isRoundedButtonLink(item)) {
                  return (
                    <li
                      key={`row-${rowIndex}-item-${itemIndex}`}
                      className={styles.Row__item}
                    >
                      <RoundedButton {...item} tabIndex={-1} />
                    </li>
                  );
                }

                return (
                  <li
                    key={`row-${rowIndex}-item-${itemIndex}`}
                    className={styles.Row__item}
                  >
                    <Card {...item} iconBoxSize={40} tabIndex={-1} />
                  </li>
                );
              })}
            </ul>
          </div>
        );
      })}
    </div>
  );
};
